import React from 'react'
import {User} from '../../../../../../../interfaces/user'
import {Dropdown} from 'react-bootstrap'
import {useSelector} from 'react-redux'
import {RootState} from '../../../../../../../redux/store'
import {useListView} from '../../../core/ListViewProvider'
import RoleBaseGuard from '../../../../../../../helpers/elements/RoleBaseGuard'

interface UserActionsCell {
  user: User
}

export const UserActionsCell = ({user}: UserActionsCell) => {
  const currentUser = useSelector((state: RootState) => state.authSlice.user)
  const {setUserIdForUpdate, setUserIdForDelete} = useListView()

  return (
    <div className='d-flex'>
      <Dropdown>
        <Dropdown.Toggle
          variant='outline-secondary'
          className='dropdown-reports-actions ps-2 pe-2 pb-1 pt-1'
        >
          <i className='fas fa-ellipsis-v ms-1 text-primary-dark'></i>
        </Dropdown.Toggle>

        <Dropdown.Menu>
          <RoleBaseGuard permission='edit_user'>
            <Dropdown.Item
              onClick={() => {
                setUserIdForUpdate(user.id)
              }}
            >
              Editar
            </Dropdown.Item>
          </RoleBaseGuard>
          <RoleBaseGuard permission='delete_user'>
            <Dropdown.Item
              onClick={() => {
                setUserIdForDelete(user.id)
              }}
            >
              Eliminar
            </Dropdown.Item>
          </RoleBaseGuard>
        </Dropdown.Menu>
      </Dropdown>
    </div>
  )
}
